import React from "react"
import PropTypes from "prop-types"
import ReactPlayer from "react-player/lazy"
import {
  ConsentPlaceholder,
  useOptionalContent,
} from "components/molecules/PrivacyConsent"

export const isYouTubeUrl = (url) =>
  typeof url === "string" &&
  /^https?:\/\/(www\.|m\.)?(youtube\.com|youtube-nocookie\.com|youtu\.be)\//i.test(
    url
  )

const ConsentVideo = ({ url, className, style, config, ...props }) => {
  const choice = useOptionalContent()
  if (isYouTubeUrl(url) && choice !== "accepted") {
    return (
      <ConsentPlaceholder
        service="YouTube"
        href={url}
        className={className}
        style={style}
      />
    )
  }
  return (
    <ReactPlayer
      {...props}
      url={url}
      className={className}
      style={style}
      config={{
        ...config,
        youtube: {
          ...config.youtube,
          embedOptions: { host: "https://www.youtube-nocookie.com" },
        },
      }}
    />
  )
}

ConsentVideo.propTypes = {
  url: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  config: PropTypes.object,
}
ConsentVideo.defaultProps = {
  url: undefined,
  className: undefined,
  style: undefined,
  config: {},
}

export default ConsentVideo
